import React, { useState, useEffect, useContext } from "react";
import "./forma.css";
import Axios from "axios";
import Select from "react-select";
import AuthContext from "../context/AuthContext";
import { API_URL } from "../components/api";

function Formo(props) {
  let [notes, setvillage] = useState([]);
  let authTokens = JSON.parse(localStorage.getItem("authTokens"));
  let { user } = useContext(AuthContext);
  // State for custom message popup
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // "success" or "error"

  function refreshPage() {
    window.location.reload(false);
  }

  useEffect(() => {
    let isMounted = true;

    const getvillage = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/administration/villages/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
              "Content-Type": "application/json",
            },
            params: {
              username: "admin",
            },
          }
        );

        if (response.status === 200 && isMounted) {
          setvillage(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    getvillage();

    return () => {
      isMounted = false;
    };
  }, []);

  const options = notes.map((item) => ({
    label: item.village_name,
    value: item.village_id,
  }));

  const [firstname, setfirst] = useState("");
  const [middlename, setmiddles] = useState("");
  const [lastname, setlast] = useState("");
  const [balance, setbalance] = useState(0);
  const [address, setaddress] = useState("");
  const [phone, setphone] = useState("");
  const [village, setvill] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await Axios.post(
        `${API_URL}/administration/clients/`,
        {
          client_id: props.sub,
          info_id: props.info,
          address_id: props.add,
          Action: "Put",
          first_name: firstname,
          email_address: "-",
          address_string: address,
          phone_number: phone,
          middle_name: middlename,
          last_name: lastname,
          village_id: village,
          userdealer: user.username,
          balance: props.balance,
          balance_id:props.balance_id,
          category:props.cat,
          collector_id:props.employee_id,
          remote:props.remote,
          office:props.office,
          potential:props.potential,
          free_collection:props.freeCollection,
        },
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
        }
      );

      // Show success message
      setMessage("Dealer information updated successfully.");
      setMessageType("success");
      setTimeout(() => setMessage(""), 3000); // Hide after 3 seconds
      refreshPage();

    } catch (error) {
      console.error(error);

      // Show error message
      setMessage("Error: Something went wrong. Please try again.");
      setMessageType("error");
      setTimeout(() => setMessage(""), 3000); // Hide after 3 seconds
    }
  };

  return (
    <div className="mod">
      {/* Custom popup message */}
      {message && (
        <div className={`message-popup ${messageType}`}>
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="name">
          <div className="form-group">
            <label>
              First Name:
              <input
                className="form-control"
                type="text"
                value={firstname}
                placeholder={props.fir}
                onChange={(e) => setfirst(e.target.value)}
              />
            </label>
          </div>
          <div className="form-group">
            <label>
              Middle Name:
              <input
                className="form-control"
                type="text"
                value={middlename}
                placeholder={props.mid}
                onChange={(e) => setmiddles(e.target.value)}
              />
            </label>
          </div>

          <div className="form-group">
            <label>
              Last Name:
              <input
                className="form-control"
                type="text"
                value={lastname}
                placeholder={props.las}
                onChange={(e) => setlast(e.target.value)}
              />
            </label>
          </div>
        </div>

        <label>
          Phone:
          <input
            className="form-control"
            type="number"
            value={phone}
            placeholder={props.pho}
            onChange={(e) => setphone(e.target.value)}
          />
        </label>
        <label>
          Village:
          <Select
            className="search-line"
            placeholder={props.vill}
            options={options}
            onChange={(opt) => setvill(opt.value)}
          />
        </label>
        <label>
          Address:
          <input
            className="form-control"
            type="text"
            value={address}
            placeholder={props.addr}
            onChange={(e) => setaddress(e.target.value)}
          />
        </label>
        <div className="fo">
          <button type="submit" className="btn btn-primary btn-md">
            Edit
          </button>
        </div>
      </form>
    </div>
  );
}

export default Formo;
